import { useState, useCallback } from "react";
import LBAConfirmation from "../../components/LBAConfirmation";
import PortalPopup from "../../components/PortalPopup";
import LogoutConfirmation from "../../components/LogoutConfirmation";
import NavigationPanel from "../../components/NavigationPanel";
import LbaForm from "../../components/LbaForm";
import Footer from "../../components/Footer.js";

const DebtorDetailsPage = () => {
  const [isLogoutConfirmationOpen, setLogoutConfirmationOpen] = useState(false);

  const closeLogoutConfirmation = useCallback(() => {
    setLogoutConfirmationOpen(false);
  }, []);

  const navItems = [
    {
      text: "Debt collection",
      bgColor: "bg-neutrals-neutral-50",
      textColor: "text-neutrals-neutral-300",
      hoverBgColor: "bg-neutrals-neutral-50",
      hoverTextColor: "text-primary-primary-500",
      path: "",
    },
    {
      text: "Outcomes & costs",
      bgColor: "bg-neutrals-neutral-50",
      textColor: "text-neutrals-neutral-300",
      hoverBgColor: "bg-neutrals-neutral-50",
      hoverTextColor: "text-primary-primary-500",
      path: "/outcome&cost",
      icon: "",
    },
    {
      text: "AI indicators",
      bgColor: "bg-neutrals-neutral-50",
      textColor: "text-neutrals-neutral-300",
      hoverBgColor: "bg-neutrals-neutral-50",
      hoverTextColor: "text-primary-primary-500",
      path: "/ai1",
      icon: "",
    },
  ];

  return (
    <div className="flex flex-col min-h-screen overflow-visible bg-neutrals-neutral-50 text-neutrals-neutral-900 font-open-sans-ff-heading-2">
      <NavigationPanel navItems={navItems} />

      <div className="w-full flex-grow px-4 md:px-24 absolute top-[136px] box-border">
        <div className="border-b-[1px] border-solid border-neutrals-neutral-100 pb-6 text-lg">
          <div className="relative font-semibold">Debtor's Details</div>
        </div>

        <div className="mt-8">
          <LbaForm />
        </div>
        <Footer />
      </div>

      {isLogoutConfirmationOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLogoutConfirmation}
        >
          <LogoutConfirmation onClose={closeLogoutConfirmation} />
        </PortalPopup>
      )}
    </div>
  );
};

export default DebtorDetailsPage;
